import { useContext, useEffect, useState } from "react";
import PageTabs from "../../Components/PageTabs";
import DataTable from "../TableMaster/DataTable";
import TableButton from "./../../Props/TableButton";
import SundryMaster from "./SundryMaster";
import SundryMasterApi from "../../../API/APIServices/BillSundry";
import AlertBox from "../../Props/AlertBox";
import MyContext from "../../MyContext";
import Loader from "../../Props/Loader";
import { useNavigate } from 'react-router-dom';

function SundryMasterList(props) {
  const {
    OpenAlertBoxDelete,
    alertBoxDelete,
    setAlertBoxDelete,
    input1,
    input2,
    input3,
    input4,
    input5,
  } = useContext(MyContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [mainData, setMainData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);

  const toggleSlider = (value) => {
    setSliderOpen(value);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const val = await SundryMasterApi.GetBillSundryFilter();
      const newData = val.map((item, i) => {
        return {
          input: <input type="checkbox" />,
          sno: i + 1,
          name: item.name,
          printName: item.printName,
          absolutePercentAmount: item.absolutePercentAmount,
          methodApplied: item.methodApplied,
          roundOffLimit: item.roundOffLimit,
          action: (
            <div className="tablelist-action-box">
              <i
                className="fa-regular fa-pen-to-square TableEditIcon"
                onClick={() => Edit(item.id)}
              ></i>
              <i
                className="fa-regular fa-trash-can TableDelIcon"
                onClick={() => DeleteAccount(item.id)}
              ></i>
              <i className="fa-brands fa-square-whatsapp TableWhatsappcon"></i>
              <i className="fa-solid fa-print TablePrint"></i>
            </div>
          ),
        };
      });
      setMainData(newData);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [getdeleteId, setDeleteId] = useState(null);

  const DeleteAccount = (id) => {
    // console.log("delete", id);
    setAlertBoxDelete(true);
    setDeleteId(id);
  };

  const DeleteAccountConfirm = async () => {
    setLoading(true);
    try {
      const val = await SundryMasterApi.deleteBillSundry(getdeleteId);
      if (Boolean(val) === true) {
        setAlertBoxDelete(false);
        setDeleteId(null);
        setLoading(false);
      } else {
        alert("Error Deleting Data");
      }
      fetchData();
    } catch (error) {
      console.error("Error deleting account:", error);
    }
  };

  //  const[data , setData] = useState({})
  const [editData, setEditData] = useState("");

  const Edit = (id) => {
    const data = SundryMasterApi.GetBillSundryById(id);
    // console.log(data);
    setEditData(data);
    toggleSlider(true);
  };

  const columns = [
    { Header: "", accessor: "input" },
    { Header: "SNO", accessor: "sno" },
    { Header: "NAME", accessor: "name" },
    { Header: " Print Name", accessor: "printName" },
    { Header: "Absolute Percent Amount", accessor: "absolutePercentAmount" },
    { Header: "method Applied", accessor: "methodApplied" },
    { Header: "Round Off Limit", accessor: "roundOffLimit" },
    { Header: "ACTION", accessor: "action" },
  ];

  const filterData = [
    { Header: "", accessor: "" },
    { Header: "", accessor: "" },
    {
      Header: <input type="text" placeholder="Name" ref={input1} />,
      accessor: "Name",
    },
    {
      Header: <input type="text" placeholder="Print Name" ref={input2} />,
      accessor: "printName",
    },
    {
      Header: (
        <input type="text" placeholder="Absolute Percent" ref={input3} />
      ),
      accessor: "absolutePercentAmount",
    },
    {
      Header: <input type="text" placeholder="Method Applied" ref={input4} />,
      accessor: "methodApplied",
    },
    {
      Header: <input type="text" placeholder="Round Off Limit" ref={input5} />,
      accessor: "roundOffLimit",
    },
  ];

  return (
    <div className="">
      <PageTabs modelOpen={props.modelOpen} locationTab={"/SundryMaster"} />
      <div className="nav-1">
        <div className="panel-heading">
          <h2 className="panel-title">Sundry Master List</h2>
          <TableButton PageCreate={"/SundryMaster"} PageName="Masters" />
        </div>
        <DataTable columns={columns} data={mainData} filterData={filterData} />
      </div>
      <div className={`slider-container100 ${isSliderOpen ? "open" : ""}`}>
        <div style={{ padding: "15px" }}>
          <SundryMaster
            data={editData}
            modelOpen={true}
            fetchData={fetchData}
            setSliderCallBack={setSliderOpen}
          />
        </div>
      </div>
      {alertBoxDelete && (
        <AlertBox
          HeadingTop="DELETE"
          Heading="Are You sure you want to delete this"
          OpenAlertBox={OpenAlertBoxDelete}
          onYesClick={DeleteAccountConfirm}
        />
      )}
      {loading && <Loader />}
    </div>
  );
}

export default SundryMasterList;
